import { useState } from 'react';
import { API_URL } from '@constants';
import { GetSpaceStatusesSuccessResponse } from '@types';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/spaces/statuses';

/**
 * Requests endpoint to get all space statuses.
 */
export const useGetSpaceStatuses = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [spaceStatuses, setSpaceStatuses] = useState<GetSpaceStatusesSuccessResponse['data']>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetSpaceStatusesSuccessResponse = await response.json();

            setSpaceStatuses(data.data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, spaceStatuses, loading };
};
